/* eslint-disable no-mixed-operators */
import React, { FunctionComponent, useEffect, useState } from "react";
import * as ReactRedux from "react-redux";
import {
  setActiveDidYouMean,
  setEmptySuggestions,
  toggleAutosuggestion
} from "../../actions/searchBoxAction";
import { highlightSearchTerm } from "../../utils/utils";
import "./GSAutoSuggestion.scss";
import { ShowAllResults } from "./ShowAllResults";
import Suggestions from "./Suggestions";
import TopResults from "./TopResults";

let GSAutoSuggestions: FunctionComponent<any> =  (props) => {
  const[ topResults , setTopResults] = useState([]);
  const[ resources , setResources] = useState([]);
  const[ suggestions , setSuggestions] = useState([]);
  const[ resultsBySuggestion , setResultsBySuggestion] = useState([]);
  const valueSuggestions = ReactRedux.useSelector((state: any) => state.searchBoxReducer.stateSearchBox);
  const [isDesktopView , setIsDesktopView] = useState(true);
  // Add 'proTab' class to auto-suggestion in Pro page.
  const proTab = document.getElementById("proTab") || null;
  const proClass = proTab && proTab.classList.contains("active") ? "protab" : "";
  const wrapperClass = `search-bar-dropdown-wrapper ${proClass}`;
  // Create a variable to contain the onfigured search result page
  const searchPageUrl = document.getElementById("hiddenSearchPageUrlDiv")?.getAttribute("searchPageUrl");
  // Add/remove overlay when auto-suggestion is opened/closed
  // Close mega menu when showing suggestion modal
  const overlay = document.getElementsByClassName("fog-of-war-overlay")[0] || null;
  const megaNav = document.querySelectorAll(".cmp-meganav.selected")[0];
  const headerTabToMegaNav = document.querySelectorAll(".header-tab-to-meganav.meganav-open")[0];
  const productMenu = document.querySelectorAll(".products-menu a.selected")[0];
  const leftMenu = document.querySelectorAll(".left-menu a.selected")[0];
  if (props.value && props.isLoadingAutosuggestion) {
    overlay?.classList.add("dropdown-open-header");
  } else {
    overlay?.classList.remove("dropdown-open-header");
    megaNav?.classList.remove("selected");
    headerTabToMegaNav?.classList.remove("meganav-open");
    productMenu?.classList.remove("selected");
    leftMenu?.classList.remove("selected");
  }

  useEffect(()=>{
    if(window.innerWidth < 1200){ // $breakpoint-xl-min: 1200px, applied for mobile view
      setIsDesktopView(false);
    }else{
      setIsDesktopView(true);
    }
  },[window.innerWidth])
  // let isDesktopView = true;
  // if (window.innerWidth < 1200) { // $breakpoint-xl-min: 1200px, applied for mobile view
  //   isDesktopView = false;
  // }
  const closeSuggestion = () => {
    props.dispatch(toggleAutosuggestion(false));
    props.dispatch(setEmptySuggestions(false));
    if (overlay) {
      overlay.classList.remove("dropdown-open-header")
    }
  }

  useEffect(() => {
    // Close suggestion modal and hide the overlay when clicking out the search box
    document.addEventListener("click", (e: any) => {
      const searchInput = document.getElementsByClassName("form-control")[0] || null;
      const modalSuggestions = document.getElementsByClassName("search-dropdown-container")[0] || null;
      if (searchInput && !searchInput.contains(e.target) && !modalSuggestions?.contains(e.target)) {
        closeSuggestion();
      }
    });
    window.addEventListener("scroll", (e) => {
      if (document.querySelector(".cmp-search-bar-dropdown")) {
        closeSuggestion();
      }
    });
  }, []);
  useEffect(()=>{
    props.suggestionsController.resultListByFistSuggestion.subscribe(()=>{
      if(resultsBySuggestion.length !== props.suggestionsController.resultListByFistSuggestion.state.results){
        setResultsBySuggestion(props.suggestionsController.resultListByFistSuggestion.state.results);
      }
    })
  },[])

  useEffect(()=>{
    props.suggestionsController.resultListAutoSuggestions.subscribe(()=>{
      if(topResults.length !== props.suggestionsController.resultListAutoSuggestions.state.results){
      setTopResults(props.suggestionsController.resultListAutoSuggestions.state.results);
      }
    })
  },[])
  useEffect(()=>{
    props.suggestionsController.resultListResourcesAutoSuggestions.subscribe(()=>{
      if(resources.length !== props.suggestionsController.resultListResourcesAutoSuggestions.state.results){
      setResources(props.suggestionsController.resultListResourcesAutoSuggestions.state.results);
      }
    })
  },[])
  useEffect(()=>{
    setSuggestions(valueSuggestions);
  },[valueSuggestions])
  // Result list to use in Top results section
  // const topResults = props.suggestionsController.resultListAutoSuggestions.state.results;
  // Result list to use in Resources section
  // const resources = props.suggestionsController.resultListResourcesAutoSuggestions.state.results;

  // Arrays to contain the list of highlighted titles
  let updatedTitle: any = [];
  let updatedTitleResource: any = [];

  highlightSearchTerm(topResults, 20, updatedTitle, props.value);
  highlightSearchTerm(resources, 6, updatedTitleResource, props.value);
  highlightSearchTerm(resultsBySuggestion, 3, updatedTitle, props.stateSearchBox[0]?.rawValue);
  const [isShownNoResult , setIsShownNoResult]= useState(false)
  const handleScrollDropdown = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  }
  useEffect(()=>{
    if(!props.stateSearchBox.length && (!isDesktopView || (isDesktopView && !topResults.length && !resources.length && !suggestions.length))){
      setIsShownNoResult(true);
    }else{
      setIsShownNoResult(false);
    }
  },[props.isActiveFilterSearchBox , props.stateSearchBox , topResults  , resources  , isDesktopView])

  const isShownSuggestion = props.stateSearchBox.length > 0 || isDesktopView && (topResults.length > 0 || resources.length > 0);
  const isSafari: boolean = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
  return (
    <div>
      {(props.value && props.isLoadingAutosuggestion) && (
        <div className={wrapperClass}>
          <div className="cmp-search-bar-dropdown">
            <div className="search-dropdown-container">
              {isShownNoResult && (
                <div className="noResult">No results found</div>
              )}
              {isShownSuggestion && (
                <div className="upper-search-dropdown-content">
                  <div className="left-side-content">
                    {props.stateDidYouMean && (
                      <div className="did-you-mean-section">
                        Did You Mean <span className="did-you-mean-value" onClick={() => props.dispatch(setActiveDidYouMean({isActiveDidYouMean: true}))}>{props.stateDidYouMean}</span>
                      </div>
                    )}
                    {suggestions.length > 0 && (
                      <Suggestions
                        isAffiliate={false}
                        didYouMean={props.stateDidYouMean}
                        className="top-searches"
                        label="Top Searches"
                        suggestions={suggestions}
                        searchPage={searchPageUrl}
                      />
                    )}
                    {isDesktopView && resources.length > 0 && (
                      <Suggestions
                        isAffiliate={false}
                        className="resources"
                        label="Resources"
                        items="6"
                        results={resources}
                        highlightedValue={updatedTitleResource}
                      />
                    )}
                  </div>
                  {isDesktopView && (topResults.length > 0  || resultsBySuggestion.length > 0) && (
                    <TopResults
                      // suggestions={suggestions}
                      isAffiliate={false}
                      value={props.value}
                      results={topResults}
                      highlightedValue={updatedTitle}
                      isSafari={isSafari}
                      resultsBySuggestion={resultsBySuggestion}
                      firstSuggestion={props.stateSearchBox[0]?.rawValue}
                    />
                  )}
                </div>
              )}
              <ShowAllResults value={props.value} searchPageUrl={searchPageUrl}/>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

GSAutoSuggestions = ReactRedux.connect((state: any, ownProps) => {
  return {
    stateSearchBox: state.searchBoxReducer.stateSearchBox,
    ...ownProps,
    value: state.searchBoxReducer.value,
    isLoadingAutosuggestion: state.searchBoxReducer.isLoadingAutosuggestion,
    stateDidYouMean: state.searchBoxReducer.stateDidYouMean,
    isActiveFilterSearchBox: state.searchBoxReducer.isActiveFilterSearchBox,
    
  };
})(GSAutoSuggestions);

export default GSAutoSuggestions;
